export class NumberUtils {
  /**
   * 絶対値変換
   * @param value
   */
  public static toAbsoluteValue(value: number): number {
    return Math.abs(value);
  }

  /**
   * 四捨五入
   * @param value
   * @param base
   */
  public static round(value: number, base: number = 1): number {
    return Math.round(value * base) / base;
  }

  /**
   * 切り捨て
   * @param value
   * @param base
   */
  public static floor(value: number, base: number = 1): number {
    return Math.floor(value * base) / base;
  }

  /**
   * 正数値は小数部以下切り捨て、負数値は切り上げる(-1.5 → -1)
   * @param value
   */
  public static plusFloorAndMinusCeil(value: number): number {
    return value >= 0 ? Math.floor(value) : Math.ceil(value);
  }

  /**
   * Array: number の平均
   * @param values
   * @param avg
   */
  public static averageFromArray(values: number[]): number {
    return values.reduce((previous, current) => previous + current) / values.length;
  }

  /**
   * 標準偏差
   * @param values
   * @param avg
   */
  public static standardDeviation(values: number[], avg: number): number {
    // [ 1 ] 配列要素の平均値との差の2乗を求める
    const squaredDifference = values.map(current => {
      const difference = current - avg;
      return difference ** 2;
    });

    // [ 2 ] [1]の配列要素の分散を求める
    const variance = squaredDifference.reduce((previous, current) => previous + current) / values.length;

    return Math.sqrt(variance);
  }
}
